/**
 * Helpers for forwarding the campaign-tracking query params (cc, sc, cmp) onto
 * outbound and restart URLs. Only params actually present on the original
 * landing URL are forwarded — synthesized defaults (e.g. GIWL's fallback
 * leadSource/campaignCode) never leak into URLs.
 */

const CAMPAIGN_PARAM_KEYS = ["cc", "sc", "cmp"] as const;

/**
 * Extracts the campaign params (cc, sc, cmp) actually present on the landing
 * URL, returned as a query string without a leading "?" ("" when none).
 */
export const getLandedCampaignSearch = (campaignUrl?: string): string => {
    if (!campaignUrl) return "";

    let landedParams: URLSearchParams;
    try {
        landedParams = new URL(campaignUrl).searchParams;
    } catch {
        return "";
    }

    const campaignParams = new URLSearchParams();
    CAMPAIGN_PARAM_KEYS.forEach((key) => {
        const value = landedParams.get(key);
        if (value) campaignParams.set(key, value);
    });
    return campaignParams.toString();
};

/**
 * Appends a query string (no leading "?") to a URL or path, respecting any
 * query the URL already carries. Returns the URL unchanged when the query
 * string is empty.
 */
export const appendSearchToUrl = (url: string, search?: string): string => {
    if (!search) return url;
    return `${url}${url.includes("?") ? "&" : "?"}${search}`;
};
